import React from "react";
import Modal from "./CommonComponents/Modal";
import OnboardAccount from "./OnboardAccount";

const OnboardAccountModal = ({ isOpen, onClose }) => {
  return (
    
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseIcon={true}
      className="onboard-university-modal"
      title={ <h1 className="oa-page-title">Create Account</h1>}
    >
        <OnboardAccount open={isOpen} setOpen={onClose} />
    </Modal>
    
  );
};

export default OnboardAccountModal;